import { render, staticRenderFns } from "./ConsultantRecords.vue?vue&type=template&id=5b9ab457&"
import script from "./ConsultantRecords.vue?vue&type=script&lang=js&"
export * from "./ConsultantRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports